export default __webpack_public_path__ + "static/media/glitch01.e5621214.png";